import { render, staticRenderFns } from "./caseIndex.vue?vue&type=template&id=1537a63a&scoped=true"
import script from "./caseIndex.vue?vue&type=script&lang=js"
export * from "./caseIndex.vue?vue&type=script&lang=js"
import style0 from "./caseIndex.vue?vue&type=style&index=0&id=1537a63a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537a63a",
  null
  
)

export default component.exports